import styled from 'styled-components';
import {
  Team as TeamType,
  Brawler as BrawlerType,
  TeamColorsValues,
  TeamIdx,
  TeamColors,
  Pick,
  PickMode,
  GuessModes,
  GuessModesValues,
} from '../common.type';
import { Brawler } from './Brawler';
import { ensureTeamIdx } from '../helpers/ensureTeamIdx';
import { useContext } from 'react';
import { LayoutContext } from '../context/LayoutContext';
import { Coin } from './Coin';
import { Eye } from './Eye';

const TeamWrapper = styled.div<{ $color: TeamColorsValues }>`
  display: flex;
  align-items: center;
  gap: ${(props) => `0.5${props.theme.unit}`};
  flex-direction: ${(props) =>
    props.$color === TeamColors.BLUE ? 'row' : 'row-reverse'};
`;
const TeamBan = styled.div`
  padding: 1vmin;
  display: flex;
  flex-direction: column;
  gap: 1vmin;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0.5vmin;
`;

const TeamDiv = styled.div<{ $color: TeamColorsValues }>`
  display: flex;
  flex-direction: column;
  gap: 2vmin;
  padding: 2vmin;
  background: ${(props) => props.theme.team[props.$color]};
  border: 0.5vmin solid #000;
  border-radius: 1vmin;
`;

type TeamProps = {
  color: 'blue' | 'red';
  team: TeamType;
  locked?: TeamType | undefined;
  coin: boolean;
  mode?: GuessModesValues | undefined;
  pick?: Pick | undefined;
  brawlers: BrawlerType[];
  onClick: (index: TeamIdx, mode: PickMode) => void;
};

export const Team = ({
  color,
  team,
  locked,
  coin,
  mode,
  pick,
  brawlers,
  onClick,
}: TeamProps) => {
  const { displayMode } = useContext(LayoutContext);
  const teamBrawler = Object.values(team).map((player) => {
    if (player.id) {
      return brawlers.find((b) => player.id === b.id);
    }
    return;
  });
  const teamBan = Object.values(team).map((player) => {
    if (player.ban) {
      return brawlers.find((b) => player.ban === b.id);
    }
    return;
  });

  return (
    <TeamWrapper $color={color}>
      <TeamBan>
        {teamBan.map((brawler, i) => {
          const idx = i + 1;
          if (!ensureTeamIdx(idx)) return;
          return (
            <Brawler
              key={`${color}-${brawler?.id.toString() ?? i.toString()}`}
              mode="ban"
              brawler={brawler}
              border={true}
              locked={locked && !!locked[idx].ban}
              selected={
                pick &&
                pick.index === idx &&
                pick.color === color &&
                pick.mode === 'ban'
              }
              onClick={() => {
                onClick(idx, 'ban');
              }}
            ></Brawler>
          );
        })}
      </TeamBan>
      <TeamDiv $color={color}>
        {teamBrawler.map((brawler, i) => {
          const idx = i + 1;
          if (!ensureTeamIdx(idx)) return;
          return (
            <Brawler
              mode="draft"
              key={`${color}-${brawler?.id.toString() ?? idx.toString()}`}
              brawler={brawler}
              border={true}
              locked={locked && !!locked[idx].id}
              selected={
                pick &&
                pick.index === idx &&
                pick.color === color &&
                pick.mode === 'brawler'
              }
              onClick={() => {
                onClick(idx, 'brawler');
              }}
            >
              {coin && idx === 1 && (
                <Coin color={color} $displayMode={displayMode} />
              )}
              {mode &&
                ((mode === GuessModes.LAST && !coin && idx === 3) ||
                  (mode === GuessModes.TWO_LAST && idx === 3)) && (
                  <Eye $displayMode={displayMode} />
                )}
            </Brawler>
          );
        })}
      </TeamDiv>
    </TeamWrapper>
  );
};
